module.exports = __webpack_public_path__ + "static/img/fish29.4262d7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/fugufish/fish29.png
// module id = tFqy
// module chunks = 0